import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';

import { Commentaire } from '../models/Commentaire';
import { NgFor, DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { CommentaireFormComponent } from '../commentaire-form/commentaire-form.component';
import { CommentaireService } from './commentaire.service';
import { GenericValidateComponent } from '../generic-components/generic-validate/generic-validate.component';

@Component({
  selector: 'app-commentaire',
  imports: [
    DatePipe,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatIconModule,
    MatToolbarModule],
  templateUrl: './commentaire.component.html',
  styleUrl: './commentaire.component.css',
})
export class CommentaireComponent implements OnInit {

  commentaires: Commentaire[] = [];
  codeDivalto!: string;


  constructor(
    public dialogRef: MatDialogRef<CommentaireComponent>,
    private commentaireService: CommentaireService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.codeDivalto = data.codeDivalto;
  }

  ngOnInit(): void {
    this.loadCommentaires();

  }


  loadCommentaires() {
    this.commentaireService.getByClient(this.codeDivalto)
      .subscribe((res:any) => {
        
        this.commentaires = res;

      }, (err:any) => {
    
      });
  }


  openCommentaire(commentaire?: Commentaire) {
    const dialogRef = this.dialog.open(CommentaireFormComponent, {
      width: '900px',
      data: { commentaire }
    });

    dialogRef.afterClosed().subscribe((result:any) => {
      if (result) {
        if (commentaire) {
          result.id = commentaire.id;
          result.codeDivalto = this.codeDivalto;
          this.commentaireService.update(result).subscribe(() => this.loadCommentaires());
        } else {
          result.codeDivalto = this.codeDivalto;
          this.commentaireService.create(result).subscribe(() => this.loadCommentaires());
        }
      }
    });
  }

  deleteCommentaire(commentaire: Commentaire) {

    const dialogRef = this.dialog.open(GenericValidateComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
      data: {
        libelle: 'VVoulez-vous vraiment supprimer ce commentaire ?',
      },
    });

    dialogRef.afterClosed().subscribe((result:any) => {
      if (result === true && commentaire.id) {
        this.commentaireService.delete(commentaire.id).subscribe(() => this.loadCommentaires());
      }
    });
  }

  fermer() {
    this.dialogRef.close(this.commentaires);
  }



}
